import { IChannelRepository } from '../../ports/IChannelRepository';
import { ChannelFilters } from '../../../shared/types/ChannelFilters';

export class CountChannelsUseCase {
  constructor(private repo: IChannelRepository) {}
  execute(filters: ChannelFilters) {
    return this.repo.count(filters);
  }
}
